document.addEventListener('DOMContentLoaded', () => {
    if (document.body.classList.contains('template-collection')) {
        const minInput = document.querySelector('.input_price_range.price_range_start');
        const maxInput = document.querySelector('.input_price_range.price_range_end');
        const minDisplay = document.querySelector('.input_price.price_input_start');
        const maxDisplay = document.querySelector('.input_price.price_input_end');

        if (minInput && maxInput && minDisplay && maxDisplay) {
            let minPrice = minInput.getAttribute('min');
            let maxPrice = maxInput.getAttribute('max');

            minInput.addEventListener('input', () => {
                if (parseFloat(minInput.value) > parseFloat(maxInput.value)) {
                    console.error('Min price cannot exceed max price!');
                    return;
                }
                minPrice = minInput.value;
                minDisplay.value = minPrice;
                console.log('Min Price:', minPrice);
            });

            maxInput.addEventListener('input', () => {
                if (parseFloat(maxInput.value) < parseFloat(minInput.value)) {
                    console.error('Max price cannot be less than min price!');
                    return;
                }
                maxPrice = maxInput.value;
                maxDisplay.value = maxPrice;
                console.log('Max Price:', maxPrice);
            });
        } else {
            console.error('Price range inputs or displays are missing!');
        }

      const targetDiv = document.querySelector('#CollectionFiltersForm');
      const urlParams = new URLSearchParams(window.location.search);
      
      const parametersToCheck = ['filter.v.availability', 'filter.v.price.gte', 'filter.v.price.lte'];
      
      const hasParameter = parametersToCheck.some(param => urlParams.has(param));
      
      if (hasParameter && targetDiv) {
          targetDiv.classList.add('clear-show');
          targetDiv.classList.remove('clear-removed');
      }
      
    }
});
